import { createAction, props } from '@ngrx/store';
import { ColorModeEnum, Language } from '@qvs/core';

const prefix = '[Preference]';

export const changeLanguage = createAction(`${prefix} change language`, props<{ lang: Language }>());
export const languageChangedSuccess = createAction(`${prefix} language changed successfully.`);

export const changeColorMode = createAction(`${prefix} change color mode`, props<{ colorMode: ColorModeEnum }>());
export const setColorModeSuccess = createAction(`${prefix} set color mode successfully.`);

export const toggleCrmFavoriteClientId = createAction(`${prefix} toggle CRM favorite client id`, props<{ clientId: string }>());
